export const SVG_MAP = [
  'M0 125 L300 125 L300 175 L0 175 Z',
  'M125 0 L175 0 L175 300 L125 300 Z',
  'M150 50 L250 150 L150 250 L50 150 Z',
  'M100,50 L200 50 L200 150 L100 200 Z'
]



// WEBPACK FOOTER //
// ./src/assets/svg_data.js